import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilterAsc: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="filter-asc"><path d="M3.75 18.25H18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 12H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 5.75H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18 21.75V13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.75 16.5L18 13.25L21.25 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFilterAsc;
